// This file sets up global variables that are needed for dependencies,
// such as @aws-amplify/auth.
// It exists as a separate file, loaded before main.ts, because, in order to
// be compliant with ESM, we cannot add code before imports.

// @ts-ignore
globalThis.global = {};
// @ts-ignore
globalThis.exports = {};
